//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios'


export default {
    data() {
            return {
                hotList: null,
                //isShow:false
                isShowPlay:false
            }
        },
        mounted() {
            axios.get('https://bird.ioliu.cn/v1?url=http://m.kugou.com?json=true')
                .then((response) => {
                    this.hotList = response.data.data.splice(0, 6);
                    console.log(this.hotList);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        filters: {
            shortTitle(input) {
                if (input.length > 15) {
                    return input.slice(0, 15) + '...';
                } else {
                    return input
                }
            }
        }
}



// WEBPACK FOOTER //
// ./src/components/xhot.vue